module.exports = __webpack_public_path__ + "img/home-hero_en.8959b31.png";